export function asciiArtLog() {
    console.info(`
    ____  _      _ ___     ___   _ 
    |  _ \\(_)_  _(_| ) \\   / / \\ | |
    | |_) | \\ \\/ / |/ \\ \\ / /|  \\| |
    |  __/| |>  <| |   \\ V / | |\\  |
    |_|   |_/_/\\_\\_|    \\_/  |_| \\_|
    `)
}